module['exports'] = ['اسلامی جمہوریہ پاکستان'];
